<template>
<span>

    <v-card v-if="loggedUser" class="pa-6 ma-md-10 bg-white-show-through">

        <!-- title -->
        <v-card-title class="card-title">
            <v-icon large class="indigo--text mr-3">{{$t('client.account.icon')}}</v-icon> {{ $t('client.account.title')}}
        </v-card-title>

        <v-divider class="my-4"></v-divider>


            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                    <tr>
                        <td>{{loggedUser.firstName}}, {{loggedUser.lastName}}</td>
                        <td>{{loggedUser.email}}</td>
                    </tr>
                     <tr>
                        <td>Téléphone : {{loggedUser.phoneNumber}}</td>
                         <td><span
                                 v-if="loggedUser.cardExpiration">Card expiration : {{loggedUser.cardExpiration}}</span></td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>



      <v-divider class="my-4"></v-divider>
      <FilesPermis></FilesPermis>

    </v-card>


</span>
</template>

<script>

  import { mapGetters } from 'vuex';
  import FilesPermis from '../components/FilesPermis'

  export default {
    name: 'Account',
    components: { FilesPermis },
    data () {
      return {}
    },
    created: function () {

    },
    computed: {
      ...mapGetters({ loggedUser: 'main/loggedUser' })
    }
  }
</script>
